import React from 'react';
import { string, shape } from 'prop-types';
import Icon from 'components/icon';

export default function TaggedTile({ item }) {
    return (
        <div className="c-tagged-tile">
            <h3>{item.title}</h3>

            <p>{item.paragraph}</p>

            <p className="tags">
                <span className="btn-tag">{item.jurisdiction}</span>
                <span className="btn-tag">{item.category}</span>
            </p>

            <div className="cta">
                <a className="btn btn-icon-small-justify btn-skin-1" href={item.ctaUrl}>
                    {item.ctaText}
                    <Icon glyph="chevron-right" />
                </a>
            </div>
        </div>
    );
}

TaggedTile.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    item: shape({
        title: string.isRequired,
        paragraph: string.isRequired,
        tags: shape({ title: string.isRequired }),
        cta: string,
        url: string
    }).isRequired
    /* eslint-enable react/no-typos */
};



// WEBPACK FOOTER //
// ./src/components/tiles/TaggedTile.jsx